import React, { useEffect, useRef, useState, useContext } from 'react'
import './Shares.css'
import cash from "../../imgs/cash.png";
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'
import { useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import dateImg from "../../imgs/bdate.png";
import { useTranslation } from "react-i18next";

const Shares = (props) => {
  const { t } = useTranslation();

  const inputRefs = useRef([]);
  const [newedit, setNewedit] = useState("new");
  const [input, setInput] = useState({
    date: new Date().toISOString().substr(0, 10),
    kno: "",
    name: "",
    type: "", // excellentdairy value: Debit/Credit
    amt: "",
    remark: "",
    tamt: "0"
  });

  const [DataSource, setDataSource] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [dates, setDates] = useState({ date1: "", date2: new Date().toISOString().substr(0, 10) });
  const [value, setValue] = useState('');
  const [sredit, setSredit] = useState('');
  const [srdelete, setSrdelete] = useState('');
  const [wait, setWait] = useState(false);

  const refprint2 = useRef(null);
  const refprint2close = useRef(null);
  const refdelete = useRef(null);
  const refdeleteclose = useRef(null);

  const { setHeadname, setsubmenu } = useContext(Globalcontext);
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);

  function handleEnterKey(event, currentIndex) {
    if (event.key === 'Enter' || event.key === "Tab") {
      event.preventDefault();
      const nextIndex = currentIndex + 1;
      if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
    }

    // Backspace to go previous input when current is empty
    if (event.key === 'Backspace' && (
      (event.target.tagName === 'INPUT' && event.target.value === '') ||
      (event.target.tagName === 'SELECT' && (
        (event.target.name === 'type' && (event.target.value === '' || event.target.value === t("shares.selectType")))
      ))
    )) {
      event.preventDefault();
      let prevIndex = currentIndex - 1;
      while (prevIndex >= 0) {
        const prevElement = inputRefs.current[prevIndex];
        if (prevElement) {
          if ((prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') && prevElement !== event.target) {
            prevElement.focus();
            break;
          }
          prevIndex--;
        } else {
          prevIndex--;
        }
      }
    }
  }

  function handleEnterKeybutton(event, currentIndex) {
    if (event.key === 'Enter') {
      event.preventDefault();
      saveShares();
      const nextIndex = currentIndex + 1;
      if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
    } else if (event.key === "Backspace") {
      if (event.target.tagName === "BUTTON") {
        if (inputRefs.current[4]) inputRefs.current[4].focus();
      }
    }
  }

  const formatDate = (dateString) => {
    const d = new Date(dateString);
    return d.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, '-');
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;

    setInput(prev => ({ ...prev, [name]: valuecurrent }));

    if (name === 'date') {
      if (valuecurrent === "" || valuecurrent === "dd/mm/yyyy" || valuecurrent > today) {
        setInput(prev => ({
          ...prev,
          date: (prev.date && prev.date <= today) ? prev.date : today
        }));
      }
    }
  };

  const handleChangedates = (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;
    setDates(prev => ({ ...prev, [name]: valuecurrent }));
  };

  useEffect(() => {
    if (input.kno === "") {
      setInput(prev => ({
        ...prev,
        kno: "",
        name: "",
        type: "",
        amt: "",
        remark: ""
      }));
      setNewedit("new");
      return;
    }

    const custlisttemp = JSON.parse(localStorage.getItem("custlist") || "[]");
    for (let i = 0; i < custlisttemp.length; i++) {
      const user = custlisttemp[i];
      if (String(user.kno) === String(input.kno)) {
        setInput(prev => ({ ...prev, name: user.cname || "" }));
        break;
      }
    }
  }, [input.kno]);

  const saveShares = () => {
    setWait(true);

    const mainuser2 = jsEncode.encode("mamapr", 125);

    // ✅ type must remain Debit/Credit (excellentdairy values)
    if (
      input.date === "" ||
      input.kno === "" ||
      input.name === "" ||
      !input.type ||
      input.amt === "" ||
      input.remark === ""
    ) {
      notifyerror(t("shares.msgIncomplete"));
      setWait(false);
      return;
    }

    const rawData = JSON.stringify({
      date: input.date,
      date1: dates.date1,
      date2: dates.date2,
      kno: input.kno,
      type: input.type, // ✅ Debit/Credit
      amt: input.amt,
      remark: input.remark,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      flag: newedit,
      sredit: sredit,
    });

    const formData = new FormData();
    formData.append('data', rawData);

    axios.post('https://excellentdairy.com/dairy/php/cust/saveshares.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      const resp = (response.data || "").toString().trim();

      if (newedit === "new") {
        notify(resp ? resp : t("shares.msgSaved"));
      } else {
        notify(resp ? resp : t("shares.msgUpdated"));
      }

      setInput(prev => ({
        ...prev,
        kno: "",
        name: "",
        type: "",
        amt: "",
        remark: ""
      }));
      setSredit("");
      setNewedit("new");

      getShares(dates.date1, dates.date2);

      if (inputRefs.current[1]) inputRefs.current[1].focus();
      setWait(false);
    }).catch(err => {
      console.log(err);
      setWait(false);
    });
  };

  const handleedit = (sr, date, kno, type, amt, remark, name) => {
    setInput(prev => ({
      ...prev,
      date: date,
      kno: kno,
      name: name || prev.name,
      type: type,   // Debit/Credit
      amt: amt,
      remark: remark
    }));
    setNewedit("edit");
    setSredit(sr);
    if (inputRefs.current[1]) inputRefs.current[1].focus();
  };

  const handlePrint = () => {
    refprint2.current?.click();
  };

  const handleprintclose = () => {
    refprint2close.current?.click();
  };

  const handleDelete = (sr) => {
    setSrdelete(sr);
    refdelete.current?.click();
  };

  const handleDeleteclose = () => {
    setSrdelete("");
    refdeleteclose.current?.click();
  };

  const deleteShares = () => {
    handleDeleteclose();

    const mainuser2 = jsEncode.encode("mamapr", 125);
    axios.post('https://excellentdairy.com/dairy/php/cust/deleteshares.php', {
      sr: srdelete,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2
    }).then(function sample(response) {
      notify(response.data || t("shares.msgDeleted"));

      setInput(prev => ({
        ...prev,
        kno: "",
        name: "",
        type: "",
        amt: "",
        remark: ""
      }));
      setSredit("");
      setNewedit("new");
      setSrdelete("");

      getShares(dates.date1, dates.date2);
      if (inputRefs.current[1]) inputRefs.current[1].focus();
    }).catch(err => console.log(err));
  };

  async function getShares(date1, date2) {
    const mainuser2 = jsEncode.encode("mamapr", 125);

    axios.post('https://excellentdairy.com/dairy/php/cust/getsharesdate.php', {
      date1: date1,
      date2: date2,
      date: input.date,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2
    }).then(function sample(response) {
      if (Array.isArray(response.data) && response.data.length > 0) {
        setDataSource(response.data);
        setInput(prev => ({ ...prev, tamt: response.data[0].tamt || "0" }));
        setTimeout(() => props.setProgress(100), 200);
        handleprintclose();
      } else {
        setDataSource([]);
        setInput(prev => ({ ...prev, tamt: "0" }));
        handleprintclose();
      }
    }).catch(err => {
      console.log(err);
      handleprintclose();
    });
  }

  useEffect(() => {
    if (inputRefs.current[1]) inputRefs.current[1].focus();

    // default period based on dur (10/15)
    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    let firstDayOfMonth;
    let lastDayOfMonth;

    if (localStorage.getItem("dur") === '10') {
      if (dayOfMonth >= 1 && dayOfMonth <= 10) { firstDayOfMonth = 1; lastDayOfMonth = 10; }
      else if (dayOfMonth >= 11 && dayOfMonth <= 20) { firstDayOfMonth = 11; lastDayOfMonth = 20; }
      else { firstDayOfMonth = 21; lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); }
    } else if (localStorage.getItem("dur") === '15') {
      if (dayOfMonth >= 1 && dayOfMonth <= 15) { firstDayOfMonth = 1; lastDayOfMonth = 15; }
      else { firstDayOfMonth = 16; lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); }
    } else {
      firstDayOfMonth = 1;
      lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    }

    const formattedDate1 = new Date(currentYear, currentMonth, firstDayOfMonth).toLocaleDateString('en-CA');
    const formattedDate2 = new Date(currentYear, currentMonth, lastDayOfMonth).toLocaleDateString('en-CA');

    setDates({ date1: formattedDate1, date2: formattedDate2 });
    getShares(formattedDate1, formattedDate2);
  }, []);

  const setNewPeriod = () => {
    getShares(dates.date1, dates.date2);
  };

  const openkarj = () => {
    setsubmenu("karj");
    setHeadname("कर्ज विभाग");
  };

  // ---------- PRINT ----------
  const cellStyle = { border: '1px solid black', padding: '4px' };

  const getTypeLabel = (type) => {
    if (type === "Debit") return t("shares.typeDebit");
    if (type === "Credit") return t("shares.typeCredit");
    return type || "-";
  };

  const printShares = () => {
    const content = document.getElementById('print-receipt-shares');
    const kendraTitle = localStorage.getItem('kendra') || '';
    const kno = input.kno || '';
    const name = input.name || '';
    const dt = input.date || '';
    const type = getTypeLabel(input.type); // ✅ print translated
    const amt = input.amt || '';
    const remark = (input.remark && input.remark !== "") ? input.remark : "-";

    if (!content) return;

    const printWindow = window.open('', '', 'width=300,height=500');
    printWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            @page { size: 58mm auto; margin: 0; }
            body { margin: 0; font-family: sans-serif; font-size: 12px; }
            .center-title { text-align: center; font-size: 11px; font-weight: bold; margin: 6px 0 2px; }
            .subinfo { font-size: 9px; font-weight: bold; margin-left: 1px; margin-bottom: 6px; line-height: 1.4; }
            .subinfo-row { display: flex; justify-content: space-between; margin-right: 6px; }
            table { border-collapse: collapse; width: 100%; margin-top: 10px; }
            th, td { border: 2px solid black; padding: 4px; text-align: center; }
            .thanks { text-align: center; font-weight: bold; font-size: 10px; margin-top: 12px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <div class="center-title">${kendraTitle}</div>

          <div class="subinfo">
            <div class="subinfo-row">
              <span>${t("shares.accountNo")}: ${kno}</span>
              <span>${t("shares.date")}: ${dt}</span>
            </div>
            <div>${t("shares.memberName")}: ${name}</div>
            <div class="subinfo-row">
              <span>${t("shares.type")}: ${type}</span>
              <span>${t("shares.amount")}: ₹${amt}</span>
            </div>
            <div>${t("shares.remark")}: ${remark}</div>
          </div>

          ${content.innerHTML}

          <div class="thanks">---------</div>
          <div class="thanks">धन्यवाद!</div>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // ---------- ENCODE ----------
  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  // ---------- UI ----------
  return (
    <>
      {/* PERIOD MODAL BUTTON */}
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden={true}
        ref={refprint2}
        data-bs-target="#sharesPeriodModal"
      />

      {/* PERIOD MODAL */}
      <div className="modal fade" id="sharesPeriodModal" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprint2close} aria-label="Close" />
            </div>
            <div className="modal-body">
              <h5 className="modal-title">{t("shares.report")}</h5>
              <div className="rowbill">
                <div className="mb-2">
                  <span className='subheadsank'>{t("shares.date")}</span>
                  <input
                    onKeyDown={e => handleEnterKey(e, 0)}
                    ref={ref => (inputRefs.current[0] = ref)}
                    type="date"
                    className="form-control"
                    autoComplete='off'
                    id="date1"
                    name="date1"
                    value={dates.date1}
                    onChange={handleChangedates}
                  />
                </div>

                <span className='subheadbill'>To</span>

                <div className="mb-2">
                  <span className='subheadsank'>{t("shares.date")}</span>
                  <input
                    disabled
                    onKeyDown={e => handleEnterKey(e, 1)}
                    ref={ref => (inputRefs.current[1] = ref)}
                    type="date"
                    className="form-control"
                    autoComplete='off'
                    id="date2"
                    name="date2"
                    value={dates.date2}
                    onChange={handleChangedates}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleprintclose}>{t("shares.delete")}</button>
              <button type="button" className="btn btn-danger" onClick={setNewPeriod}>{t("shares.search")}</button>
            </div>
          </div>
        </div>
      </div>

      {/* DELETE MODAL BUTTON */}
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden={true}
        ref={refdelete}
        data-bs-target="#sharesDeleteModal"
      />

      {/* DELETE MODAL */}
      <div className="modal fade" id="sharesDeleteModal" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close" />
            </div>
            <div className="modal-body">
              <h5 className="modal-title">{t("shares.msgDeleteConfirm")}</h5>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleDeleteclose}>{t("shares.close")}</button>
              <button type="button" className="btn btn-danger" onClick={deleteShares}>{t("shares.delete")}</button>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="khadyamain">
        <div className="firstrowkhadya">
          <img onClick={props.visibility} className='back' src={back} alt="" />
          <div className="colmainkhadya">
            <div className="firstrow2">
              <div className="row1kh100">
                <div className="mb-2">
                  <span className='subheadsank'>{t("shares.date")}</span>
                  <input
                    onKeyDown={e => handleEnterKey(e, 0)}
                    ref={ref => (inputRefs.current[0] = ref)}
                    type="date"
                    className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                    autoComplete='off'
                    id="date"
                    name="date"
                    value={input.date}
                    onChange={handleChange}
                  />
                </div>

                <div className="rightkhsaletop">
                  <div onClick={handlePrint}>
                    <img className='khadyaicon' src={dateImg} alt="" />
                    <span className='khsaleblack'>
                      {t("shares.report")} :
                      <span className='khsaleblue'>{formatDate(dates.date1)} - {formatDate(dates.date2)}</span>
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className='linekh' />

        <div className="row1uchal">
          <div className="mb-2">
            <span className='subheadsank'>{t("shares.accountNo")}</span>
            <input
              onKeyDown={e => handleEnterKey(e, 1)}
              ref={ref => (inputRefs.current[1] = ref)}
              type="number"
              className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
              autoComplete='off'
              id="kno"
              name="kno"
              value={input.kno}
              onChange={handleChange}
            />
          </div>
          <div className="mb-2">
            <span className='subheadsank'>{t("shares.memberName")}</span>
            <input
              type="text"
              disabled
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
              autoComplete='off'
              id="name"
              name="name"
              value={input.name}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className='linekh' />

        <div className="row1uchal">
          <div className="mb-2">
            <span className='subheadsank'>{t("shares.type")}</span>

            {/* UI translated, VALUE = Debit/Credit */}
            <select
              onKeyDown={e => handleEnterKey(e, 2)}
              ref={ref => (inputRefs.current[2] = ref)}
              value={input.type || ""}
              name='type'
              id='type'
              onChange={handleChange}
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            >
              <option value="">{t("shares.selectType")}</option>
              <option value="Debit">{t("shares.typeDebit")}</option>
              <option value="Credit">{t("shares.typeCredit")}</option>
            </select>
          </div>

          <div className="mb-2">
            <span className='subheadsank'>{t("shares.amount")}</span>
            <input
              onKeyDown={e => handleEnterKey(e, 3)}
              ref={ref => (inputRefs.current[3] = ref)}
              type="number"
              className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
              autoComplete='off'
              id="amt"
              name="amt"
              value={input.amt}
              onChange={handleChange}
            />
          </div>

          <div className="mb-2">
            <span className='subheadsank'>{t("shares.remark")}</span>
            <input
              type="text"
              onKeyDown={e => handleEnterKey(e, 4)}
              ref={ref => (inputRefs.current[4] = ref)}
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
              autoComplete='off'
              id="remark"
              name="remark"
              value={input.remark}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row1uchal2">
          <div className="row1khsale">
            {wait ? (
              <button type="submit" className="btn btn-primary mx-1 sanksmall">
                {t("shares.search")}
              </button>
            ) : (
              <button
                onClick={saveShares}
                onKeyDown={e => handleEnterKeybutton(e, 0)}
                ref={ref => (inputRefs.current[5] = ref)}
                type="submit"
                className="btn btn-primary mx-1 sanksmall"
              >
                {newedit === "new" ? t("shares.save") : t("shares.update")}
              </button>
            )}

            <button
              type="button"
              className="btn btn-primary mx-1 sanksmall"
              onClick={printShares}
            >
              {t("shares.report")}
            </button>
          </div>

          <div className="rightkhsale">
            <img className='khadyaicon' src={cash} alt="" />
            <span className='uchalblack'>
              {t("shares.totalAmount")} :
              <span className='khsalered'>₹{parseFloat(input.tamt || 0).toFixed(2)}</span>
            </span>
          </div>
        </div>

        <div className="firstrow2">
          <div className="table-containeruchal">
            <table id="myTable" className="table table-bordered">
              <thead>
                <tr>
                  <th className='thsmall'>{t("shares.sr")}</th>
                  <th className='thsmall'>{t("shares.date")}</th>
                  <th className='thsmall'>{t("shares.accountNo")}</th>
                  <th className='thlarge'>{t("shares.name")}</th>
                  <th className='thsmall'>{t("shares.type")}</th>
                  <th className='thsmall'>{t("shares.amount")}</th>
                  <th className='thsmall'>{t("shares.action")}</th>
                </tr>
              </thead>

              <tbody>
                {(value.length > 0 ? tableFilter : DataSource).map((user, index) => (
                  <tr key={index}>
                    <td className='thsmallaudit'>{index + 1}</td>
                    <td className='thsmallaudit'>{user.date}</td>
                    <td className='thsmallaudit'>{user.kno}</td>
                    <td className='thsmallaudit'>{user.name}</td>

                    {/* UI translated for Debit/Credit */}
                    <td className='thsmallaudit'>{getTypeLabel(user.type)}</td>

                    <td className='thsmallaudit'>{parseFloat(user.amt || 0).toFixed(2)}</td>

                    <td className='thsmallaudit'>
                      <UilEditAlt
                        onClick={() => handleedit(user.sr, user.date, user.kno, user.type, user.amt, user.remark, user.name)}
                        className="icsank"
                      />
                      <UilTrash
                        onClick={() => handleDelete(user.sr)}
                        className="icsank"
                      />
                    </td>
                  </tr>
                ))}
                {(value.length === 0 && DataSource.length === 0) && (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center" }}>{t("shares.msgNoData")}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Hidden print table */}
        <div id="print-receipt-shares" style={{ display: 'none' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '12px', textAlign: 'center' }}>
            <thead>
              <tr>
                <th style={cellStyle}>{t("shares.type")}</th>
                <th style={cellStyle}>{t("shares.amount")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={cellStyle}>{getTypeLabel(input.type)}</td>
                <td style={cellStyle}>₹{parseFloat(input.amt || 0).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ToastContainer />
      </div>
    </>
  );
};

export default Shares;
